import React from 'react';
import { MultiSlideCarouselComponent } from "../../../library/cms/content-components";
import JsUtility from "../../../library/utils/utility";

export class MultiSlideCarouselComponent1 extends MultiSlideCarouselComponent {

    onClick = (file) => {
        let link = file.link;
        if (link) {
            location.href = link;
        }
    }

    getNodes() {
        var index = 0;
        var nodes = this.state.component.content.media.map((file) => {
            var fileUrl = file.url;
            var title = file.title;
            return (
                <carousel-item class="" key={index++} onClick={() => this.onClick(file)}>
                    <div>
                        <img src={fileUrl} />
                    </div>
                    <div className="span">{title}
                    </div>
                </carousel-item>
            );
        });

        return nodes;

    }
}

class CarouselItem extends React.Component {
    constructor(props) {
        super(props);
        let file = this.props.file;
        this.originalSrc=file.url;
        this.src =file.url;
        this.src2 = JsUtility.toAltUrl(file.url);
    }

    onClick = (file) => {
        let link = file.link;
        if (link) {
            location.href = link;
        }
    }

    onMouseEnter = (file) => {
        this.src=this.src2;
        this.forceUpdate();
    }

    onMouseLeave = (file) => {
        this.src=this.originalSrc;
        this.forceUpdate();
    }

    render(){
        let file=this.props.file;
        let title=file.title;
        return(
            <carousel-item onClick={() => this.onClick(file)}>
                <div>
                    <img className="image-filter-1" src={this.src} onMouseEnter={() => this.onMouseEnter(file)} onMouseLeave={()=>this.onMouseLeave(file)} />
                </div>
                <div className="span">{title}
                </div>
            </carousel-item>
        );
    }


}

export class MultiSlideAltCarouselComponent extends MultiSlideCarouselComponent {

    getNodes() {
        var index = 0;
        var nodes = this.state.component.content.media.map((file) => {
            return (
                <CarouselItem key={index++} file={file} />
            );
        });

        return nodes;

    }
}

export default {MultiSlideCarouselComponent1, MultiSlideAltCarouselComponent}